import { FIELD_TYPES } from "constants/template-field-type";
import FullParagraphFieldsConfig from "segments/desktop/core-components/full-paragraph/fields-config";
import ProductsTabs from "segments/desktop/core-components/products-tabs/fields-config";

export default {
  type: FIELD_TYPES.NESTED,
  label: "Side By Side Paragraph And Products",
  fields: {
    fullParagraph: {
      type: FIELD_TYPES.NESTED,
      label: "Full paragraph",
      fields: FullParagraphFieldsConfig
    },
    productTabs: {
      type: FIELD_TYPES.NESTED,
      label: "Product tabs",
      fields: ProductsTabs
    }
  }
};
